export const CardGroupSettings = (settingsProps) => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
